module.exports = __webpack_public_path__ + "static/ParkAvePH-c47a4be42a2a1cd263572c43e9a24a7a.jpg";